import { Injectable } from '@angular/core';
import { DatadogRumService } from './datadog-rum.service';
import { SupplierInboxType } from '../enums/supplier-inbox.type.enum';

export type SupplierInteractionName =
  | 'TravelSchedulerView'
  | 'TravelSchedulerInteraction'
  | 'BuyJobAttempt'
  | 'BuyJobSuccess'
  | 'RejectJobAttempt'
  | 'RejectJobSuccess'
  | 'WatchJobAttempt'
  | 'WatchJobSuccess'
  | 'JobSelect'
  | 'JobDetailsView'
  | 'UnwatchJobSuccess'
  | 'RemoveJobFromSupplierSuccess'
  | 'RouteDetailsView';

@Injectable({ providedIn: 'root' })
export class SupplierJobInteractionService {
  constructor(private datadogRumService: DatadogRumService) {}

  public logSingleJobInteraction(name: SupplierInteractionName, jobId: number, ctx: any = {}) {
    this.datadogRumService.addAction(name, {
      ...ctx,
      jobId,
      interaction: 'supplier-job-interaction',
    });
  }

  public getEngineiusViewName(location: Location): string | null {
    if (location.pathname == '/app/supplierinbox') {
      return this.getSupplierInboxViewName(location);
    }
    return null;
  }

  private getSupplierInboxViewName(location: Location): string | null {
    let url = new URL(location.href);
    let selectedTab = url.searchParams.get('selectedTab');

    if (!selectedTab) {
      return null;
    }

    let inboxType: SupplierInboxType = Number(selectedTab);

    let viewName = SupplierInboxType[inboxType];

    if (url.searchParams.get('isGridView') == 'true') {
      viewName += '_Grid';
    }

    return viewName;
  }
}
